











































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
// import { firstDayInPrevMonth, formatDateTime } from "@/global.ts";
import GlobalMixins from "@/global.mixin";

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class SiteLocations extends Vue {
  @State("locations") locationsState: any;

  @Action("getLocations") getLocations: any;
  @Action("saveLocation") saveLocation: any;
  @Action("deleteLocation") deleteLocation: any;

  @State("sites") sitesState: any;
  @Action("getSites") getSites: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  formValid = false;

  sitesSearchTerm = "";
  sitesSearched: string[] = [];

  editingDialog = false;
  isNewLocation = false;
  defaultItem = {
    locationId: 0,
    name: "",
    description: "",
    siteId: -1,
    isInUse: false,
  };
  editedItem = Object.assign({}, this.defaultItem);
  editedIndex = -1;
  dollySearchTerm = "";
  localDollies = [];

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "name",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("locations-rowsPerPage") ?
                        parseInt(this.$cookies.get("locations-rowsPerPage"), 10) : 25
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  // tslint:disable:max-line-length
  getHeaders() { return [
    { text: "#", value: "locationId", width: "1%", align: "left", sortable: true},
    { text: this.$t("LOCATIONS_TABLE_HEADER_SITE"), value: "site.code", width: "1%", align: "left", sortable: true },
    { text: this.$t("LOCATIONS_TABLE_HEADER_NAME"), value: "name", width: "1%", align: "left", sortable: true },
    { text: this.$t("LOCATIONS_TABLE_HEADER_DESCRIPTION"), value: "description", width: "1%", align: "left", sortable: true },
    { text: this.$t("TABLE_ACTIONS"), value: "", sortable: false,  }
  ];
  }

  async created() {
    // Check for required siteId parameter early in component lifecycle
    if (!this.$route.params.siteId) {
      this.$router.replace({ name: "sites" });
      return;
    }

    await this.getSites();
    this.searchSites(null);
  }

  searchSites(e) {
    if (!this.sitesSearchTerm) {
      this.sitesSearched = this.sitesState.sites;
      return;
    }

    this.sitesSearched = this.sitesState.sites.filter((item) => {
      return item.code.indexOf(this.sitesSearchTerm.toUpperCase()) > -1 ||
             item.description.indexOf(this.sitesSearchTerm.toUpperCase()) > -1;
    });
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column, sortable) {
    if (!sortable) {
      return;
    }

    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("locations-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
      id: this.$route.params.siteId,
    };
    this.getLocations(page);
  }

  newSiteLocation() {
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    this.editedItem.siteId = parseInt(this.$route.params.siteId, 10);

    this.isNewLocation = true;
  }

  save() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.saveLocation({
        data: JSON.stringify(
          {
            ...this.editedItem,
            siteId: this.$route.params.siteId
          }),
          index: this.editedIndex
      })
      .then(res => {
        this.close();
      })
      .catch(res => {
        // handle....
        // this.close();
      });
    }
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    if (this.$refs.form) {
      (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation();
    }
  }

  editItem(item) {
    this.isNewLocation = false;
    this.editedIndex = this.locationsState.locations.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }

  deleteItem(item) {
    const index = this.locationsState.locations.indexOf(item);

    if (confirm(this.$t("LOCATION_DELETE_CONFIRM") as string)) {
      this.deleteLocation({ id: item.locationId, index });
    }
  }

  back() {
    this.$router.back();
  }
}
